import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSlotRemaining } from "../../hooks/api/BookingValueCalendarController";
import { useBookingState } from "../../hooks/useBookingState";
import { toNumberString } from "../../utils/common";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import { SelectTagArea } from "../detail/SelectTagArea";

export const TimeSlotSelection: React.FC<{
  calendarConfig?: TCalendarConfig;
  activeTimeSlots?: any[];
  onTimeSlotChange: (timeSlotValue: any) => void;
  destDate?: string;
  productId?: number;
  mode: TProdAttrPickerMode;
}> = ({
  activeTimeSlots,
  onTimeSlotChange,
  calendarConfig,
  productId,
  destDate,
  mode,
}) => {
  const { t } = useTranslation();
  const bookingState = useBookingState({
    mode,
  });
  const bookingStateRoot = useBookingState({
    mode: "FORM",
  });
  // const timeSlots = useMemo(() => {
  //   const start = 8;
  //   const end = 19;
  //   const ret: OptionProps[] = [];
  //   for (let i = start; i <= end; i++) {
  //     const x = (i + "").padStart(2, "0");
  //     ret.push({
  //       displayName: `${x}:00 ${i >= 12 ? "PM" : "AM"}`,
  //       value: `${x}00`,
  //     });
  //   }
  //   return ret;
  // }, []);
  const timeSlots = useMemo(() => {
    if (!calendarConfig?.timeSlots) return [];

    return calendarConfig.timeSlots
      .map((slot: string) => {
        const time = +toNumberString(slot);
        const formattedTime = time.toString().padStart(4, "0");
        const hours = +formattedTime.slice(0, 2);
        const minutes = formattedTime.slice(2);
        // Extract maxNumberOfGuests for this slot
        let maxNumberOfGuests = calendarConfig.defaultMaxNumberOfGuests;
        if (
          calendarConfig.timeSlotConfigs &&
          calendarConfig.timeSlotConfigs[slot]
        ) {
          maxNumberOfGuests =
            calendarConfig.timeSlotConfigs[slot].maxNumberOfGuests;
        }
        return {
          displayName: `${hours}:${minutes} ${hours >= 12 ? "PM" : "AM"}`,
          value: (time + "").padStart(4, "0"),
          maxNumberOfGuests,
        };
      })
      .sort((a: any, b: any) => +a.value - +b.value);
  }, [calendarConfig]);

  let selectedTimeSlot:
    | {
        displayName: string;
        value: string;
        maxNumberOfGuests?: number;
      }
    | undefined = undefined;
  if (activeTimeSlots && activeTimeSlots.length > 0) {
    selectedTimeSlot = timeSlots.find(
      (slot: any) => slot.value === activeTimeSlots[0],
    );
  }

  const maxNumberOfGuests = calendarConfig?.defaultMaxNumberOfGuests;

  const { slotRemaining, slotRemainingMap } = useSlotRemaining({
    destDate,
    productId,
    timeSlot: selectedTimeSlot?.value,
    maxNumberOfGuests,
  });
  const isPass = bookingStateRoot.product?.productType === "PASS";
  const count = isPass
    ? ProdAttrUtils.PASS.findPeopleQty(bookingStateRoot.bookingAttributes)
    : ProdAttrUtils.countPerson(bookingState);

  if (!timeSlots.length) return <div>{t("No time slots available")}</div>;
  const isShowText = (slotRemaining?: number) => {
    if (!maxNumberOfGuests) return false;
    if (
      typeof slotRemaining !== "number"
        ? false
        : slotRemaining !== -1 && slotRemaining - count <= 5
    ) {
      return true;
    }
    return false;
  };
  const isDisabled = (slotRemaining?: number) => {
    if (!maxNumberOfGuests) return false;
    if (
      typeof slotRemaining !== "number"
        ? false
        : slotRemaining !== -1 && slotRemaining - count < 0
    ) {
      return true;
    }
    if (typeof maxNumberOfGuests === "number") {
      return count > maxNumberOfGuests;
    }
    return false;
  };
  return (
    <div className="time-slot-selection">
      <SelectTagArea
        options={timeSlots.map((slot) => ({
          ...slot,
          disabled: isDisabled(slotRemainingMap?.[slot.value]),
        }))}
        defaultSelected={activeTimeSlots}
        onSelect={(options) => {
          onTimeSlotChange(options[0]?.value);
        }}
        title={t("Select Time")}
      />
      {isShowText(slotRemaining) && !!selectedTimeSlot?.value && (
        <>
          {slotRemaining < count ? (
            <div className="text-sm text-[tomato]">
              {t("There arent enough seats left", {
                num: slotRemaining, // Ensure non-negative
              })}
              .
            </div>
          ) : (
            <div className="text-sm text-[tomato]">
              {t("Only 1 spot left", {
                num: slotRemaining, // Ensure non-negative
              })}
              !
            </div>
          )}

          {slotRemaining < count && (
            <style>
              {` 
            .cart--btn {
              opacity: 0.5;
              pointer-events: none;
            }
            .popup-apply--btn {
              background-color: #DCDCDC;
              color: white;
            }
          `}
            </style>
          )}
        </>
      )}
    </div>
  );
};
